module.exports = __webpack_public_path__ + "img/ic_star_off.c663bb94.svg";